
import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { LucideIcon } from 'lucide-react';

interface RoomCountSelectProps {
  icon: LucideIcon;
  label: string;
  fieldName: string;
  defaultValue: string;
  readOnly?: boolean;
}

// Function to create number array for select options
const createNumberArray = (max: number) => {
  return Array.from({ length: max + 1 }, (_, i) => i.toString());
};

const RoomCountSelect = ({ 
  icon: Icon, 
  label, 
  fieldName, 
  defaultValue, 
  readOnly = false 
}: RoomCountSelectProps) => {
  const { setValue, watch } = useFormContext();
  const value = watch(fieldName, defaultValue);

  return (
    <div className="form-group">
      <Label className="form-label flex items-center gap-2">
        <Icon size={16} />
        {label}
      </Label>
      <Select
        defaultValue={value}
        onValueChange={(value) => setValue(fieldName, value)}
        disabled={readOnly}
      >
        <SelectTrigger className={`form-select ${readOnly ? "bg-gray-100" : ""}`}>
          <SelectValue placeholder={`Seleccionar cantidad`} />
        </SelectTrigger>
        {!readOnly && (
          <SelectContent>
            {createNumberArray(50).map(num => (
              <SelectItem key={`${fieldName}-${num}`} value={num}>{num}</SelectItem>
            ))}
          </SelectContent>
        )}
      </Select>
    </div>
  );
};

export default RoomCountSelect;
